import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';

import Layouts from './layouts';

const getPageDescription = (page) => {
    if (!isEmpty(page.summary || '')) {
        return page.summary;
    }
    const textBlock = (page.blocks || []).find(block => block.type === 'text');
    return typeof textBlock !== 'undefined' ? textBlock.description : null;
};

const mediaTypes = ['media', 'image'];
const getPageThumbnail = (page) => {
    const mediaBlock = (page.blocks || []).find(block => (
        mediaTypes.indexOf(block.type) !== -1 && typeof block.picture !== 'undefined'
    ));
    return typeof mediaBlock !== 'undefined' ? mediaBlock.picture.url : null;
};

const propTypes = {
    routeParams: PropTypes.object.isRequired,
    pages: PropTypes.array.isRequired,
};

const defaultProps = {

};

class Page extends Component {

    getPage() {
        const { pages, routeParams } = this.props;
        const search = routeParams.post_slug || routeParams.page_slug || routeParams.hub_slug || 'index';
        return pages.find(it => it.slug === search) || null;
    }

    render() {
        const page = this.getPage();

        if (page === null || typeof Layouts[page.type] === 'undefined') {
            return null;
        }

        const LayoutComponent = Layouts[page.type];

        const className = classNames({
            container: true,
            'container-page': true,
            [`page-color-${page.color || 'red'}`]: true,
        });

        const title = `I am still your child | ${page.title}`;
        const description = getPageDescription(page);
        const thumbnail = getPageThumbnail(page);

        return (
            <div className={className}>
                <Helmet>
                    <title>{ title }</title>
                    <meta property="og:title" content={title} />
                    { !isEmpty(description) ? (
                        <meta name="description" content={description} />
                    ) : null }
                    { !isEmpty(description) ? (
                        <meta property="og:description" content={description} />
                    ) : null }
                    { !isEmpty(thumbnail) ? (
                        <meta property="og:image" content={thumbnail} />
                    ) : null }
                </Helmet>
                <LayoutComponent key={`page-${page.id}`} {...page} />
            </div>
        );
    }
}

Page.propTypes = propTypes;
Page.defaultProps = defaultProps;

const PageContainer = connect(state => ({
    pages: state.site.pages,
}))(Page);

export default withRouter(PageContainer);



// WEBPACK FOOTER //
// ./components/Page.jsx